import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  block: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2),

    '&.alt': {
      gap: 0,
      flexDirection: 'column'
    }
  },
  input: {
    marginBottom: theme.spacing(),
    '& fieldset': {
      backgroundColor: theme.palette.primary.contrastText,
      borderColor: theme.palette.primary.main,
      borderRadius: 3,
      minHeight: 45
    },
    '& .MuiInputAdornment-root': {
      zIndex: 2
    },

    '& label': {
      color: theme.palette.primary.main,
      fontWeight: 500,
      backgroundColor: theme.palette.primary.contrastText,
      paddingRight: theme.spacing()
    },
    '& input': {
      zIndex: 1,
      fontWeight: 500
    },

    '&.alt': {
      '& input': {
        maxWidth: 45
      }
    },
    '& > p': {
      color: theme.palette.secondary.contrastText
    }
  },
  position: {
    width: 105,
    flexShrink: 0
  },
  points: {
    [theme.breakpoints.up('lg')]: {
      width: 305
    }
  },
  addLink: {
    margin: theme.spacing(2, 0),
    fontSize: '.75rem',
    fontWeight: 600,
    textDecoration: 'underline',
    cursor: 'pointer',
    alignSelf: 'flex-start'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 507,
    overflowY: 'auto',
    [theme.breakpoints.up('lg')]: {
      width: 450,
      paddingRight: theme.spacing(2),
      margin: '0 auto'
    }
  },
  assistancePointTitle: {
    fontSize: '.875rem',
    fontWeight: 600
  },
  otherContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  altOtherContainer: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'center'
    }
  },
  numberLabel: {
    fontSize: '.875rem'
  },
  altErrorMessage: {
    fontSize: '.75rem'
  },
  deleteButton: {
    marginTop: theme.spacing(0.5)
  },
  optionController: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  switchContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5)
  }
}))
